import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';

import {
  Feature,
  FeatureCommands,
  FeatureNames,
  GatewayCommands,
  GatewayProperties,
  UserRoleType,
} from '@vi-iot/client';

import { GTMService } from '@services';
import { InstallationDetailsStore, InstallationFeaturesStore } from '@store';

import { ReplaceGatewayModalComponent } from '../replace-gateway-modal/replace-gateway-modal.component';
import { DeregisterConfirmationModalComponent } from '../deregister-confirmation-modal/deregister-confirmation-modal.component';

@Component({
  selector: 'app-gateway-menu',
  templateUrl: './gateway-menu.component.html',
  styleUrls: ['./gateway-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GatewayMenuComponent implements OnInit {
  status$: Observable<Feature<GatewayProperties, GatewayCommands>>;
  rsaRolesForDeregister = [
    UserRoleType.admin,
    UserRoleType.supportInternational,
    UserRoleType.supportInternationalWithRemoteDiagnosis,
    UserRoleType.supportLocalReadWrite,
    UserRoleType.supportLocalReadWriteWithRemoteDiagnosis,
    UserRoleType.supportLocalDepartmentManagement,
  ];
  UserRoleType = UserRoleType;

  @Input() gatewaySerial: string;
  @Input() installationId: number;

  constructor(
    public installationDetailsStore: InstallationDetailsStore,
    public installationFeaturesStore: InstallationFeaturesStore,
    private dialog: MatDialog,
    private gtmService: GTMService
  ) {}

  ngOnInit(): void {
    this.status$ = this.installationFeaturesStore.selectInstallationGatewayFeature(
      FeatureNames.gatewayStatus
    );
  }

  rebootGateway(): void {
    this.installationFeaturesStore.updateFeature(
      FeatureNames.gatewayStatus,
      null,
      null,
      null,
      FeatureCommands.reboot,
      null,
      null
    );
    this.gtmService.track('rebootGateway');
  }

  cancelRebootGatewayConfirmation(): void {
    this.gtmService.track('onCancel', 'Reboot gateway confirmation', 'gateway');
  }

  refreshDeviceList(): void {
    this.installationDetailsStore.refreshDeviceList(this.installationId, this.gatewaySerial);
  }

  cancelRefreshDeviceListConfirmation(): void {
    this.gtmService.track('onCancel', 'Refresh device list confirmation', 'gateway');
  }

  openDeregisterConfirmationModal(gatewaySerial?: string): void {
    this.dialog.open(DeregisterConfirmationModalComponent, {
      data: {
        installationId: this.installationId,
        gatewaySerial,
      },
    });
  }

  openReplaceGatewayModal(): void {
    this.dialog.open(ReplaceGatewayModalComponent, {
      width: '800px',
    });
  }
}
